import * as actionTypes from './actionTypes';
import axios from "axios";
import api from '../../utilities/api';
import { getMessage } from '../../utilities/getMessage';

export const rejectBet=(id,token)=>async dispatch=>{
    dispatch({
        type:actionTypes.REJECT_BET_START,
    })
    const options={
        url:`${api}/bets/${id}/reject`,
        method:'POST',
        headers:{
            'Authorization':`Bearer ${token}`
        },
        data:{}
    }
    await axios(options)
            .then(response=>dispatch({
                type:actionTypes.REJECT_BET_SUCCESS,
                payload:response.data
            }))
            .catch(error=>dispatch({
                type:actionTypes.REJECT_BET_FAIL,
                payload:getMessage(error)
            }))
}